var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDemandNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.398 14.745H.545A.543.543 0 010 14.202V5.798c0-.3.244-.543.544-.543h1.853c.3 0 .543.243.543.543v8.404c0 .3-.243.543-.543.543zM19.839 10.373l-1.31 1.31a.544.544 0 01-.77 0l-4.277-4.276a.544.544 0 010-.768l1.31-1.31a.544.544 0 01.77 0l4.277 4.276a.542.542 0 010 .768z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.483 13.361l1.31 1.31a.544.544 0 00.77 0l4.277-4.276a.544.544 0 000-.768l-1.31-1.31a.544.544 0 00-.77 0l-4.277 4.276a.544.544 0 000 .768z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.001 10.926V9.074c0-.3.244-.543.544-.543h15.03c.3 0 .544.243.544.543v1.852c0 .3-.244.544-.544.544H.545A.543.543 0 010 10.926z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandNew);
export default __webpack_public_path__ + "static/media/demand-new.59a8212584317339cb249197e1c6b416.svg";
export { ForwardRef as ReactComponent };